import { render, staticRenderFns } from "./ScenarioPage.vue?vue&type=template&id=840c27c2&"
import script from "./ScenarioPage.vue?vue&type=script&lang=js&"
export * from "./ScenarioPage.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports